/*
This file was created by the script build.py 
*/

import {getAllFiltered} from "./filter";
import {searchObjectSmAnalysisCharacteristics} from "./searchObjects"



export function fillSearchObjectSmAnalysisCharacteristics(){
    searchObjectSmAnalysisCharacteristics.categories = [];
    searchObjectSmAnalysisCharacteristics.keywords = [];

    const checkbox = document.getElementById("categorySmAnalysisCharacteristics");
    if(checkbox.checked || checkbox.indeterminate){
        searchObjectSmAnalysisCharacteristics.categories.push(checkbox.value);
    }

    const anyButton = document.getElementById("buttonSmAnalysisCharacteristicsAny");
    if(anyButton.classList.contains("chosen")){
        searchObjectSmAnalysisCharacteristics.any = true;
    }

    const allButton = document.getElementById("buttonSmAnalysisCharacteristicsAll");
    if(allButton.classList.contains("chosen")){
        searchObjectSmAnalysisCharacteristics.any = false;
    }
    
    const buttonCouplingsandOrproperties = document.getElementById("buttonSmAnalysisCharacteristicsCouplingsandOrproperties");
    if(buttonCouplingsandOrproperties.classList.contains('selected')){
        searchObjectSmAnalysisCharacteristics.keywords.push(buttonCouplingsandOrproperties.value)
    }
    
    const buttonCrossSection = document.getElementById("buttonSmAnalysisCharacteristicsCrossSection");
    if(buttonCrossSection.classList.contains('selected')){
        searchObjectSmAnalysisCharacteristics.keywords.push(buttonCrossSection.value)
    }
    
    const buttonMassandOrwidth = document.getElementById("buttonSmAnalysisCharacteristicsMassandOrwidth");
    if(buttonMassandOrwidth.classList.contains('selected')){
        searchObjectSmAnalysisCharacteristics.keywords.push(buttonMassandOrwidth.value)
    }
    
    const buttonMeasurement = document.getElementById("buttonSmAnalysisCharacteristicsMeasurement");
    if(buttonMeasurement.classList.contains('selected')){
        searchObjectSmAnalysisCharacteristics.keywords.push(buttonMeasurement.value)
    }
    
    const buttonRareProductionandDecays = document.getElementById("buttonSmAnalysisCharacteristicsRareProductionandDecays");
    if(buttonRareProductionandDecays.classList.contains('selected')){
        searchObjectSmAnalysisCharacteristics.keywords.push(buttonRareProductionandDecays.value)
    }
    
    const buttonSpectroscopy = document.getElementById("buttonSmAnalysisCharacteristicsSpectroscopy");
    if(buttonSpectroscopy.classList.contains('selected')){
        searchObjectSmAnalysisCharacteristics.keywords.push(buttonSpectroscopy.value)
    }
    
    getAllFiltered()

}